"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailWrapper = exports.ThumbnailList = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject, _templateObject2;

var ThumbnailList = _styledComponents["default"].ul.withConfig({
  displayName: "Thumbnailsstyles__ThumbnailList",
  componentId: "sc-1e37uwq-0"
})(["", " ", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref) {
  var _theme$gallery$thumbn, _theme$gallery, _theme$gallery$thumbn2;

  var theme = _ref.theme;
  return (_theme$gallery$thumbn = theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$thumbn2 = _theme$gallery.thumbnail) === null || _theme$gallery$thumbn2 === void 0 ? void 0 : _theme$gallery$thumbn2.list) !== null && _theme$gallery$thumbn !== void 0 ? _theme$gallery$thumbn : 'flex flex-row justify-center pa0';
}), function (_ref2) {
  var _ref2$theme = _ref2.theme;
  _ref2$theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  var _ref2$theme$gallery = _ref2$theme.gallery;
  _ref2$theme$gallery = _ref2$theme$gallery === void 0 ? {} : _ref2$theme$gallery;
  var thumbnail = _ref2$theme$gallery.thumbnail;
  return thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.overrides;
});

exports.ThumbnailList = ThumbnailList;

var ThumbnailWrapper = _styledComponents["default"].li.withConfig({
  displayName: "Thumbnailsstyles__ThumbnailWrapper",
  componentId: "sc-1e37uwq-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref3) {
  var _theme$gallery$thumbn3, _theme$gallery2, _theme$gallery2$thumb;

  var theme = _ref3.theme;
  return (_theme$gallery$thumbn3 = theme === null || theme === void 0 ? void 0 : (_theme$gallery2 = theme.gallery) === null || _theme$gallery2 === void 0 ? void 0 : (_theme$gallery2$thumb = _theme$gallery2.thumbnail) === null || _theme$gallery2$thumb === void 0 ? void 0 : _theme$gallery2$thumb.wrapper) !== null && _theme$gallery$thumbn3 !== void 0 ? _theme$gallery$thumbn3 : 'mh1 w-auto flex flex-shrink-0 flex-grow-0';
}));

exports.ThumbnailWrapper = ThumbnailWrapper;